<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
        <el-breadcrumb-item>信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>协议管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <el-row class="mb20">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="handleEdit()"
              >添加协议</el-button
            >
      </el-row> -->
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
      <el-table-column
          label="协议类型"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.flag==0?'用户协议':'隐私协议' }}
          </template>
        </el-table-column>
        <el-table-column
          label="协议名称"
          align="center"
          prop="agreeName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="协议备注"
          align="center"
          min-width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        
        <el-table-column
          label="创建时间"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.createDate }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(999, scope.row)"
              >查看</el-button
            >
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row, '')"
              >编辑</el-button
            >
            <!-- <el-button
              size="mini"
              type="danger"
              @click="deleteProduct(scope.$index, scope.row)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑界面 -->
      <el-drawer
        :title="title"
        :visible.sync="editFormVisible"
        size="70%"
        :wrapperClosable="false"
        @close="closeDialog('editForm')"
      >
        <el-form
          label-width="120px"
          :model="editForm"
          ref="editForm"
          :rules="rules"
        >
          <el-row :gutter="10">
            <el-row>
              <el-col :span="12">
                <el-form-item label="协议类型" prop="adaptationDisease">
                  <el-select
                    size="small"
                    disabled="true"
                    class="full_select"
                    v-model="editForm.flag"
                    placeholder="请选择协议类型">
                    <el-option
                    v-for="item in typeOptions"
                    :key="item.id + '-ppkey'"
                    :label="item.label"
                    :value="item.id"
                    >
                    </el-option>
                </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="协议名称" prop="agreeName">
                  <el-input
                    v-model="editForm.agreeName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="协议备注" prop="remark">
                  <el-input
                    v-model="editForm.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :span="24">
              <el-form-item label="协议内容" prop="agreeMent">
                <editor v-model="editForm.agreeMent" :min-height="592" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dr-footer" style="text-align: center">
          <el-button size="small" @click="closeDialog('editForm')"
            >取消</el-button
          >
          <el-button
          v-if="isEdit"
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
      </el-drawer>
    </div>
  </template>
  
  <script>
  import {
    getUserAgreeList,updateUserAgreeList,addUserAgreeList,delUserAgreeList
  } from "../../api/basisMG";
  import Pagination from "../../components/Pagination";
  export default {
    data() {
      return {
        disabled: false,
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: "预览",
        isEdit:false,
        typeOptions:[
            {label:'用户协议',id:'0'},{label:'隐私协议',id:'1'},
        ],
        uploadheaders: {
          Authorization: localStorage.getItem("logintoken"),
        },
        rules: {
          detailImage: [
            { required: true, message: "请添加药品详情图片", trigger: "change" },
          ],
        },
        editForm: {
        },
        formInline: {
          page: 1,
          limit: 10,
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10,
        },
        isGroundingBtn:true, //批量按钮禁用
        ids:'',
      };
    },
    // 注册组件
    components: {
      Pagination,
      // LocalQuillEditor
    },
    created() {
      this.getdata();
    },
    methods: {
      resetForm() {
        this.detailImageArr = []; //清除保存图片No的数组缓存 避免连续上传重复
        this.editForm = {
        
        };
      },
      resetFormLine() {
        this.formInline = {
          page: 1,
          limit: 10,
        };
      },
      // 富文本内容
      editChange(e) {
        // console.log(e,'富文本change时的值');
        this.editForm.description = e.html;
      },
      // 获取列表
      getdata() {
        this.loading = true;
        getUserAgreeList().then((res) => {
            this.loading = false;
            if (res.rsp_code !== 200) {
              this.$message({
                type: "info",
                message: res.rsp_msg,
              });
            } else {
              this.listData = res.body;
              // 分页赋值
            //   this.pageparm.currentPage = this.formInline.page;
            //   this.pageparm.pageSize = this.formInline.limit;
            //   this.pageparm.total = res.body.total;
            }
          })
          .catch((err) => {
            callFather;
            this.loading = false;
            this.$message.error("加载失败，请稍后再试！");
          });
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage;
        this.formInline.limit = parm.pageSize;
        this.getdata(this.formInline);
      },
      // 搜索事件
      search() {
        this.formInline.page=1
        this.getdata(this.formInline);
      },
      //显示编辑界面
      handleEdit: function (index, row, typeName) {
        this.editFormVisible = true;
        this.isEdit = true
        if(index==999){
           this.isEdit = false
        }
          if (row != undefined && row != "undefined") {
            this.title = "修改";
            this.editForm = row;
            this.editForm.id = row.id
            this.editForm.createDate =new Date(this.editForm.createDate)
            this.editForm.updateDate =new Date(this.editForm.updateDate)
          } else {
            this.noneBtnImg = false;
            this.title = "添加";
            this.editForm = {};
          }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate((valid) => {
          if (valid) {
            let subType = this.title == "添加" ? addUserAgreeList : updateUserAgreeList;
            subType(this.editForm)
              .then((res) => {
                this.loading = false;
                if (res.rsp_code == 200) {
                  this.getdata();
                  this.editFormVisible = false;
                  this.$message({
                    type: "success",
                    message: "保存成功！",
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.rsp_msg,
                  });
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("保存失败，请稍后再试！");
              });
          } else {
            // 校验不通过滑动到该位置
            this.moveToErr();
          }
        });
      },
      // 滑动到未
      moveToErr() {
        this.$nextTick(() => {
          let isError = document.getElementsByClassName("is-error");
          if (isError.length) {
            isError[0].scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            // 这个当滑动到报错项之后自动获取输入框的焦点，方便用户直接进行输入，延迟 800ms 是因为需要都能到定位成功后在进行获取焦点体验更好一些
            setTimeout(() => {
              if (isError[0].previousElementSibling.querySelector("input")) {
                isError[0].previousElementSibling.querySelector("input").focus();
              }
            }, 800);
          }
        });
      },

      // 删除公司
      deleteProduct(index, row) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delUserAgreeList(row.id)
              .then((res) => {
                if (res.rsp_code == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.getdata();
                } else {
                  this.$message({
                    type: "info",
                    message: res.rsp_msg,
                  });
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("删除失败，请稍后再试！");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.getdata();
        this.editFormVisible = false;
        this.$refs[formName].resetFields();
      },
    },
  };
  </script>
  <style>
  .hide_search_box{
    position: relative;
    margin-top: 60px;
  }
  .hide_search{
    position: absolute;
    top: -50px;
    right: 20px;
  }
  .ql-container {
    height: 80%;
  }
  .el-form-item__content .el-input-group {
    vertical-align: middle;
  }
  .el-upload__tip {
    line-height: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-upload--picture-card,
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  /* 上传按钮显示隐藏 */
  .uoloadSty .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .disUoloadSty .el-upload--picture-card {
    display: none; /* 上传按钮隐藏 */
  }
  .el-drawer__body {
    overflow-x: hidden;
    padding-right: 20px;
    padding-bottom: 60px;
  }
  .el-drawer__body::-webkit-scrollbar {
    height: 10px;
    width: 12px;
  }
  .el-drawer__body::-webkit-scrollbar-thumb {
    background: rgb(55, 88, 236);
  }
  .dr-footer {
    padding: 20px 0;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }
  </style>
  <style scoped>
  .table-img {
    margin: 0 5px;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: -1px;
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   
  
   


// WEBPACK FOOTER //
// src/views/img/protocol.vue